import React, { useState, useEffect } from 'react';

import './fade-slider.css';

// Slider con transizione a dissolvenza: le slide sono sovrapposte e cambia solo l'opacità
const FadeSlider = ({ children, delay = 8000, speed = 1000, className = '' }) => {
  const items = React.Children.toArray(children).filter(Boolean);
  const [activeIndex, setActiveIndex] = useState(0);

  // Avanzamento automatico, riparte da zero quando si clicca un pallino
  useEffect(() => {
    if (items.length < 2) return undefined;

    const timer = setTimeout(() => {
      setActiveIndex((current) => (current + 1) % items.length);
    }, delay);

    return () => clearTimeout(timer);
  }, [activeIndex, items.length, delay]);

  if (items.length === 0) return null;

  return (
    <div className={`fade-slider ${className}`}>
      <div className="fade-slider-stage">
        {items.map((item, index) => (
          <div
            key={item.key ?? index}
            className={`fade-slider-item ${index === activeIndex ? 'active' : ''}`}
            style={{ transitionDuration: `${speed}ms` }}
            aria-hidden={index !== activeIndex}
          >
            {item}
          </div>
        ))}
      </div>

      {items.length > 1 && (
        <div className="fade-slider-dots">
          {items.map((item, index) => (
            <button
              key={item.key ?? index}
              type="button"
              className={`fade-slider-dot ${index === activeIndex ? 'active' : ''}`}
              onClick={() => setActiveIndex(index)}
              aria-label={`Slide ${index + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default FadeSlider;
